// Filtro de drill-down del Dashboard B2B (uno a la vez).
//
// Solo estas gráficas responden al filtro y muestran el ícono de gráfica filtrable (no todas tienen clic: las de
// visitas, "Pedidos por canal", "Total Pedidos", "Clientes fidelizados", "Pedidos por Familias" y "Cartera por edades" solo se filtran). Debe coincidir con DashboardB2bService::FILTERABLE_CHARTS.
export const FILTERABLE_CHARTS = [
    'visits_compliance_monthly',
    'visits_efficiency_monthly',
    'orders_by_channel',
    'orders_last_12_months',
    'orders_by_seller',
    'orders_by_line',
    'orders_by_brand',
    'top_10_customers',
    'top_10_products',
    'loyal_customers_by_seller',
    'orders_by_family',
    'receivables_aging'
]

// Filtros que NO aplican a las gráficas de visitas (Cumplimiento y Eficiencia): con ellos esas gráficas siguen sin
// filtrar y sin badge. Debe coincidir con DashboardB2bService::VISITS_IGNORED_FILTERS.
export const VISITS_IGNORED_FILTERS = ['brand', 'product', 'family']

// Filtros que SÍ aplican a "Cartera por edades" (la cartera no se divide por producto ni por mes): con los demás
// la gráfica sigue sin filtrar y sin badge. Debe coincidir con DashboardB2bService::RECEIVABLES_FILTERS
// ('loyal' / 'not_loyal' llegan al backend como lista de clientes).
export const RECEIVABLES_FILTERS = ['seller', 'customer', 'loyal', 'not_loyal']

// Gráficas filtrables que NO muestran el ícono del cubo (se siguen filtrando igual).
export const FILTER_ICON_HIDDEN = ['visits_compliance_monthly', 'visits_efficiency_monthly', 'orders_by_channel', 'receivables_aging']

// Prefijo del badge verde según el tipo de filtro.
export const FILTER_LABELS = {
    seller: 'Vendedor',
    line: 'Grupo',
    brand: 'Marca',
    customer: 'Cliente',
    product: 'Producto',
    family: 'Familia',
    month: 'Mes',
    loyal: 'Clientes fidelizados',
    not_loyal: 'Clientes NO fidelizados'
}
